import { ADMIN_PATH } from '@/constants';

export const ADMIN_LIST_PATH = 'list';

export const getAdminListUrl = () => `/${ADMIN_PATH}/${ADMIN_LIST_PATH}`;